import z from "zod";

export const ImageSchema = z.object({
  name: z.string(),
  type: z.union([z.literal("file"), z.literal("folder")]),
  path: z.string(),
  new: z.boolean().optional().catch(undefined),
  url: z.string().optional().catch(undefined),
  size: z.string().optional().catch(undefined),
  contentType: z.string().optional().catch(undefined),
  extension: z.string().optional().catch(undefined),
  all: z.unknown().optional().catch(undefined),
  date: z.union([z.string(), z.number()]).catch(""),
});

export const ImagesSchema = z.array(ImageSchema);

export type IImage = z.infer<typeof ImageSchema>;

export const DeletedItemSchema = z.object({
  name: z.string(),
  type: z.union([z.literal("file"), z.literal("folder")]),
  path: z.string(),
  /**
   * Present only for items of `type: "file"`. May be a transient `blob:` URL
   * for files that were uploaded in the same session but never persisted to
   * the backend — hosts cannot fetch those.
   */
  url: z.string().optional(),
  key: z.string().nullable(),
});

export type IDeletedItem = z.infer<typeof DeletedItemSchema>;
